import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { authenticatedRoute } from "../_authenticated.js";

export const crmDealsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/crm/deals",
  component: lazyRouteComponent(() => import("./crm-deals.page.js"), "CrmDealsPage"),
});
